import { MarketingLayout } from "../components/MarketingLayout";
import { LegalDoc } from "../components/LegalDoc";
import { useSEO } from "../lib/useSEO";

const SECTIONS = [
  {
    heading: "1. Agreement to Terms",
    body: [
      "These Terms & Conditions govern your access to and use of the Alea ERP platform. By creating an account or using the service, you agree to be bound by these terms.",
      "If you are entering into these terms on behalf of an organization, you represent that you have authority to bind that organization.",
    ],
  },
  {
    heading: "2. Accounts and Tenants",
    body: [
      "When you register, a secure company tenant is provisioned for your organization, and the registering user becomes its administrator.",
      "You are responsible for maintaining the confidentiality of your credentials and for all activity that occurs under your account.",
      "You must provide accurate information and keep it up to date.",
    ],
  },
  {
    heading: "3. Acceptable Use",
    body: [
      "You agree to use Alea ERP only for lawful business purposes and in compliance with all applicable laws and regulations.",
      "You may not attempt to access data belonging to other tenants, disrupt the service, reverse-engineer the platform, or use it to store unlawful content.",
    ],
  },
  {
    heading: "4. Subscriptions and Billing",
    body: [
      "Paid plans are billed according to the pricing in effect at the time of purchase, including per-employee pricing where applicable.",
      "Free trials convert to paid subscriptions only with your explicit confirmation. You may upgrade, downgrade or cancel in accordance with your plan terms.",
      "Fees are non-refundable except where required by law.",
    ],
  },
  {
    heading: "5. Customer Data",
    body: [
      "You retain all rights to the data you submit to Alea ERP. You grant us a limited license to process that data solely to provide and improve the service.",
      "You are responsible for the accuracy, legality and appropriate use of the data you enter.",
    ],
  },
  {
    heading: "6. Service Availability",
    body: [
      "We strive to maintain high availability and provide an uptime commitment on eligible plans.",
      "We may perform maintenance, updates and improvements that temporarily affect availability, and will aim to minimize disruption.",
    ],
  },
  {
    heading: "7. Intellectual Property",
    body: [
      "The Alea ERP platform, including its software, design and trademarks, is owned by us and protected by applicable laws.",
      "These terms do not grant you any right to our intellectual property except the limited right to use the service.",
    ],
  },
  {
    heading: "8. Limitation of Liability",
    body: [
      "To the maximum extent permitted by law, Alea ERP shall not be liable for indirect, incidental or consequential damages arising from your use of the service.",
      "Our total liability for any claim is limited to the amounts paid by you for the service in the twelve months preceding the claim.",
    ],
  },
  {
    heading: "9. Termination",
    body: [
      "You may stop using the service at any time. We may suspend or terminate access for breach of these terms or to comply with legal obligations.",
      "Upon termination, your right to use the service ceases, subject to data retention as described in our Privacy Policy.",
    ],
  },
  {
    heading: "10. Changes and Contact",
    body: [
      "We may update these terms from time to time. Material changes will be communicated, and continued use constitutes acceptance.",
      "Questions about these Terms & Conditions can be sent to hello@aleaerp.com.",
    ],
  },
];

export default function Terms() {
  useSEO({
    title: "Terms & Conditions",
    description: "The terms that govern your use of the Alea ERP platform.",
    path: "/terms",
  });

  return (
    <MarketingLayout>
      <LegalDoc title="Terms & Conditions" updated="June 2026" sections={SECTIONS} />
    </MarketingLayout>
  );
}
